import { graphql, useStaticQuery } from 'gatsby';

type SanityFAQItem = {
  id: string;
  question: string;
  answer: Array<object>;
};

type SanityFAQItems = Array<SanityFAQItem>;

type SanityFAQ = { faqItems: SanityFAQItems };

type SanityFAQResult = { sanityFaq: SanityFAQ };

function useSanityFAQ(): SanityFAQItems {
  const { sanityFaq } = useStaticQuery<SanityFAQResult>(graphql`
    query SanitySiteFAQQuery {
      sanityFaq {
        faqItems {
          id: _key
          question
          answer: _rawAnswer(resolveReferences: { maxDepth: 50 })
        }
      }
    }
  `);
  return sanityFaq.faqItems;
}

export { useSanityFAQ };
export type { SanityFAQ, SanityFAQResult, SanityFAQItem, SanityFAQItems };
